//
export const ACC_USER_AVATAR_VIEW = 'ACC_USER_AVATAR_VIEW';
export const ACC_USER_AVATAR_VIEW_SUCCESS = 'ACC_USER_AVATAR_VIEW_SUCCESS';
export const ACC_USER_AVATAR_VIEW_FAIL = 'ACC_USER_AVATAR_VIEW_FAIL';
export const ACC_USER_AVATAR_VIEW_RESET = 'ACC_USER_AVATAR_VIEW_RESET';
export const ACC_USER_AVATAR_VIEW_CLEAR_CACHE = 'ACC_USER_AVATAR_VIEW_CLEAR_CACHE';
